import { Form } from "src/components/Form/Form";
import type { WizardMetadata } from "./types";

export function StepMetadata(props: {
  metadata: WizardMetadata;
  onChange: (patch: Partial<WizardMetadata>) => void;
}) {
  return (
    <div className="flex flex-col space-y-3 min-w-[420px]">
      <Form.Text
        label="Report name"
        value={props.metadata.name}
        type="text"
        autoFocus
        maxLength={120}
        placeholder="My design — concept report"
        onChange={(name) => props.onChange({ name })}
      />
      <Form.Area
        label="Notes (optional)"
        value={props.metadata.notes}
        placeholder="Any context the report should include…"
        onChange={(notes) => props.onChange({ notes })}
      />
    </div>
  );
}
